import { For, createSignal, createEffect } from "solid-js";
import { CheckIcon, getCheckColor } from "./check_icon";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function Denominations() {
  const gridState = useDenominationGridContext();
  const { 
    denominationList, 
    customSelected, 
    setCustomSelected,
    denominationBorderClass,
    externalProps,
    internalState 
  } = gridState;
  
  const { 
    selectedAmount, 
    setSelectedAmount, 
    dryRunErrorMessage: errorMessage
  } = internalState;
  
  const { 
    isDarkTheme 
  } = externalProps;

  return (
    <For each={denominationList}>
      {(amount) => {
        let [isSelectedAmount, setIsSelectedAmount] = createSignal<boolean>(
          selectedAmount() == amount
        );

        createEffect(() => {
          setIsSelectedAmount(selectedAmount() == amount && !customSelected());
        });

        return (
          <div
            class={`${denominationBorderClass} `}
            classList={{
              "!border-basePrimaryDark dark:!border-baseTertiaryLight":
                isSelectedAmount() && errorMessage() === null,
              "light:border-neutral-200 dark:border-baseDark ":
                !isSelectedAmount(),
              "border-2": isSelectedAmount(),
              border: !isSelectedAmount(),
              "bg-baseTertiaryLight": true,
              "border-errorDark hover:border-errorDark":
                isSelectedAmount() && errorMessage() != null,
            }}
            onClick={() => {
              setCustomSelected(false);
              setSelectedAmount(amount);
            }}
          >
            <div class="text-bold">
              <span>₹{amount}</span>
            </div>
            <div
              class="absolute right-[9px] top-[1px] h-[6px] w-[9px]"
              classList={{
                "group-hover:block": !isSelectedAmount(),
                block: isSelectedAmount(),
                hidden: !isSelectedAmount(),
                [getCheckColor({
                  isSelected: isSelectedAmount(),
                  isDarkTheme: isDarkTheme ?? false,
                })]: true,
              }}
            >
              <CheckIcon />
            </div>
          </div>
        );
      }}
    </For>
  );
}
